(function ($) {
	'use strict';

	$(function () {

		/**
		 * Add smooth scrolling for arrow button
		 */
		$('a.scrollto').on('click', function (e) {

			e.preventDefault();

			const target = $(this).attr('href');
			const offset = $(this).data('offset') || 20;
			const $target = $(target);

			//set localscroll so that we offset by fixed menu if present
			GENThemeTools.scrollTo($target, 750, offset);

			//briefly highlight the target
			const origColor = $target.css('background-color');

			//color is faded $color-brand-asia
			$target.css('background-color', 'rgba(220,182,28,0.5)');

			setTimeout(function () {
				$target.css('transition', '1.5s background ease-in');
				$target.css('background-color', origColor);
			}, 1500);

		});

	});

}(jQuery));